var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FieldText, HelpIcon, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withPhoneNumbers } from 'hocs';
import { validateName } from 'utils/formValidator';
import PrettyNumber from '../PrettyNumber';
import '../telephony.less';
class EditNumberModal extends PureComponent {
    handleFormSubmit(values) {
        const { name, record_outbound_calls } = values;
        const { phoneNumbers: { update }, selectedNumber: { e164_format: number }, hideEditNumberModal, fetchNumbers, } = this.props;
        if (number) {
            update({
                number,
                name,
                record_outbound_calls,
            })
                .then(hideEditNumberModal)
                .then(fetchNumbers)
                .catch((exception) => {
                console.error('edit number exception', exception);
            });
        }
    }
    render() {
        const { isShown, selectedNumber, featureflags, hideEditNumberModal, handleSubmit, } = this.props;
        const numberE164Format = selectedNumber && selectedNumber.e164_format
            ? selectedNumber.e164_format
            : '';
        let outboundNumberDescription = `Only number that are verified for outbound calling can enable call recording. When outbound call recording is enabled all outbound calls from the number ${numberE164Format} is recorded.`;
        let disabledOutbound = true;
        if (selectedNumber && selectedNumber.outgoing_functionality) {
            outboundNumberDescription = `Record all outbound calls made with phone number ${numberE164Format}.`;
            disabledOutbound = false;
        }
        if (featureflags.is_callrecording_allowed == false) {
            outboundNumberDescription = `Call recording is disabled on this organization.`;
            disabledOutbound = true;
        }
        return (_jsxs(Modal, Object.assign({ isOpen: isShown, onClose: hideEditNumberModal }, { children: [_jsxs(ModalHead, Object.assign({ title: "Settings", onClose: hideEditNumberModal }, { children: ["Change the settings of the phone number:", ' ', _jsx(PrettyNumber, { number: selectedNumber })] })), _jsx(ModalBody, { children: _jsx("form", Object.assign({ onSubmit: handleSubmit(this.handleFormSubmit), id: "editNumberForm" }, { children: _jsxs("div", Object.assign({ className: "edit-number-modal__body" }, { children: [_jsx(Field, { label: "Name", name: "name", component: FieldText, type: "text", placeholder: "(e.g. Customer support)", helpIcon: {
                                        title: 'Name',
                                        text: 'Give this number a name so everyone on your team knows what this phone number will be used for (e.g. Customer Support, complaints, high-priority, etc.).',
                                    }, validate: validateName }), _jsxs("div", Object.assign({ className: "edit-number-modal__body-outbound" }, { children: [_jsxs("p", { children: ["Record outbound calls", _jsx("span", Object.assign({ className: "edit-number-modal__body-outbound__help" }, { children: _jsx(HelpIcon, { title: "Outbound call recording", text: outboundNumberDescription }) }))] }), _jsx(Field, { label: "Outbound call recording", name: "record_outbound_calls", component: FieldSwitch, type: "checkbox", placeholder: "(e.g. Customer support)", disabled: disabledOutbound })] }))] })) })) }), _jsx(ModalFoot, { cancelOnClick: hideEditNumberModal, confirmOnClick: handleSubmit(this.handleFormSubmit), confirmProps: {
                        type: 'submit',
                        form: 'editNumberForm',
                    }, confirmName: "Save" })] })));
    }
}
__decorate([
    boundMethod
], EditNumberModal.prototype, "handleFormSubmit", null);
const WrappedEditNumberModal = withPhoneNumbers(EditNumberModal);
export default reduxForm({
    form: 'editNumberModal',
    enableReinitialize: true,
})(WrappedEditNumberModal);
